import React from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import * as _R from 'ramda'
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import { formatName } from '../../common/common';
import { TreeSelectComponent } from '../../common/TreeSelectComponent';
import * as _ts from '../../common/treeSelect';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
const API_URL = process.env.REACT_APP_API_URL;

export const SyncMappingReportComponent = (props) => {
const gridStyle = {
        margin: '15px 0px'
    };

    return (
         <Paper>
            <div className={'p1'}>
                <Typography variant="h6" component="h6" className={'section-title'}>Sync Mapping Report</Typography>
                <form id="export-form" className="form-fullwidth" action={API_URL+'api/report/exportSyncMappingReport'} method="post">
                    <Grid container spacing={2} style={gridStyle}>
                        <Grid item  md={3} className='justify-between'>
                            <FormControl  variant="standard">
                                <InputLabel htmlFor="emp_category">Destination Instance</InputLabel>
                                    <Select
                                        value = {_R.type(props.ReportFields.dest_instance) !== 'Undefined' ? props.ReportFields.dest_instance : '-1'}
                                        onChange={props.HandleOnChange}
                                        inputProps={{
                                            name: 'dest_instance',
                                            id:   'dest_instance',
                                        }}>
                                        <MenuItem value={"-1"}>All</MenuItem>
                                        {_R.type(props.DestinationInstanceList) != 'Undefined' && props.DestinationInstanceList.map((ss, i) =>
                                        <MenuItem value={i}>{ss}</MenuItem>
                                        )}
                                    </Select>
                            </FormControl>
                        </Grid>
                         <input type='hidden' name='included_staff' value={JSON.stringify(props.ReportFields.included_staff || [])}/>
                         <Grid item  md={6}>
                            <FormControl>
                              <Autocomplete
                                    value = {(typeof props.ReportFields.included_src_staff !== 'undefined' && props.ReportFields.included_src_staff) ? props.ReportFields.included_src_staff  : [props.FormInputs.src_staff_list[0]]}
                                    onChange={props.handleSourceUserChange}
                                    multiple
                                    id="tags-outlined"
                                    options={ (typeof props.FormInputs.src_staff_list !== 'undefined') ? props.FormInputs.src_staff_list : []}
                                    getOptionLabel={(option) => formatName(option.first_name, null, option.last_name)}
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Source Users"
                                            placeholder="Users"
                                        />
                                    )}
                                /> 
                            </FormControl>
                            </Grid>
                        <Grid item  md={3} className='justify-between'>
                            <FormControl  variant="standard">
                                <InputLabel htmlFor="emp_category">Sync Status</InputLabel>
                                    <Select
                                        value = {_R.type(props.ReportFields.sync_status) !== 'Undefined' ? props.ReportFields.sync_status : '1'}
                                        onChange={props.HandleOnChange}
                                        inputProps={{
                                            name: 'sync_status',
                                            id:   'sync_status',
                                        }}>
                                        <MenuItem value={-1}>All</MenuItem>
                                        <MenuItem value={1}>Active</MenuItem>
                                        <MenuItem value={0}>Inactive</MenuItem>
                                    </Select>
                            </FormControl>
                        </Grid>
                         <Grid item md={3}>
                            <Grid container spacing={2} style={gridStyle}>
                                <Button variant="contained" type="submit" size="small" color="primary" >Export</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </Paper>
    )
}
